var _defs, _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.956,
    height: 132.792,
    viewBox: "0 0 135.956 132.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7412",
    "data-name": "Rectangle 7412",
    width: 5.652,
    height: 6.165,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11177",
    "data-name": "Rectangle 11177",
    width: 79.843,
    height: 79.526,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11176",
    "data-name": "Rectangle 11176",
    width: 77.221,
    height: 3.133,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16969",
    "data-name": "Group 16969",
    transform: "translate(5528.211 14088.907)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7408",
    "data-name": "Rectangle 7408",
    width: 128.093,
    height: 0.89,
    transform: "translate(-5527.316 -13957.006)",
    fill: "#d3d7df"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28177",
    "data-name": "Path 28177",
    d: "M44.945,131.173A373.208,373.208,0,0,1,39.6,67.4c.11-34.722,13.911-56.535,28.379-61.988,28.823-10.8,39.729,8.013,51.08,26.821,2.782,4.563,11.353,18.585,25.82,21.7,9.682,2.114,16.137-1.892,22.7,2.894,1.781,1.335,5.676,4.785,7.345,15.692,3.449,22.48-8.236,48.411-13.8,58.649Z",
    transform: "translate(-5567.812 -14087.735)",
    fill: "#edeff8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28178",
    "data-name": "Path 28178",
    d: "M101.207,7.319c-.556,1.892,4.341,3,9.906,10.127,5.675,7.122,4.117,10.016,8.9,17.25,1.78,2.671,8.012,12.019,19.363,14.913,1.447.334,14.245,3.561,18.363-2.114,5.231-7.122-4.562-27.043-19.92-36.5-15.47-9.571-35.612-7.456-36.615-3.673",
    transform: "translate(-5560.862 -14087.523)",
    fill: "#edeff8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28201",
    "data-name": "Path 28201",
    d: "M35.636,99.4a4.22,4.22,0,0,1,3,1.558A8.222,8.222,0,0,1,40.2,104.07a13.344,13.344,0,0,1-.445,6.9c-2.337-.89-3.784-3.339-4.452-4.674-1-2.114-1.669-6.566.334-6.9",
    transform: "translate(-5553.491 -14077.661)",
    fill: "#5843be"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11504",
    "data-name": "Group 11504",
    transform: "translate(-5510.904 -13970.407)",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11503",
    "data-name": "Group 11503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11502",
    "data-name": "Group 11502",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28202",
    "data-name": "Path 28202",
    d: "M42.366,112.621a3.634,3.634,0,0,1-.223-3.673,4.689,4.689,0,0,1,2.894-2.337,2.014,2.014,0,0,1,1.781.111,1.451,1.451,0,0,1,.556,1.447,3.9,3.9,0,0,1-.668,1.558,6.524,6.524,0,0,1-4.34,2.894",
    transform: "translate(-41.75 -106.457)",
    fill: "#5843be"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28203",
    "data-name": "Path 28203",
    d: "M42.57,119.6a1.755,1.755,0,0,0-.111-.445c-.111-.334-.111-.779-.223-1.224a11.924,11.924,0,0,1-.223-4.118,8.4,8.4,0,0,1,1.558-3.9,6.6,6.6,0,0,1,.89-.89c.111-.111.223-.111.334-.223a.109.109,0,0,0,.111-.111,4.949,4.949,0,0,0-1.224,1.224,7.927,7.927,0,0,0-1.447,3.784,11.924,11.924,0,0,0,.223,4.118,8.316,8.316,0,0,0,.223,1.224,1.948,1.948,0,0,0-.111.556",
    transform: "translate(-5552.635 -14076.611)",
    fill: "#1a2e35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28204",
    "data-name": "Path 28204",
    d: "M36.2,102.3a.345.345,0,0,0,.111.223c.111.111.111.334.223.556.223.445.445,1.113.89,1.892.668,1.669,1.669,3.9,2.671,6.455s1.781,4.9,2.448,6.566a20.483,20.483,0,0,1,.668,2c.112.223.112.445.223.556v.223a.346.346,0,0,0-.11-.223,1.89,1.89,0,0,0-.224-.556c-.223-.445-.445-1.113-.779-2-.667-1.669-1.447-4.006-2.448-6.566s-1.892-4.785-2.56-6.455c-.334-.779-.556-1.447-.779-2-.111-.223-.111-.445-.334-.668h0",
    transform: "translate(-5553.281 -14077.333)",
    fill: "#1a2e35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28205",
    "data-name": "Path 28205",
    d: "M40.885,114.614a8.39,8.39,0,0,0-6.677-4.118c-.668,0-1.558.111-1.892.668-.334.668.111,1.335.556,1.892a7.433,7.433,0,0,0,8.013,1.781",
    transform: "translate(-5553.733 -14076.407)",
    fill: "#5843be"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28206",
    "data-name": "Path 28206",
    d: "M34.9,112.1h.446a1.212,1.212,0,0,1,.556.111c.221,0,.444.111.667.111.224.111.556.111.78.223.333.111.556.223.889.334a11.88,11.88,0,0,1,1.893,1.113,10.253,10.253,0,0,1,1.557,1.558,3.382,3.382,0,0,1,.556.779c.112.223.335.445.445.668a1.584,1.584,0,0,1,.224.668c.11.223.11.334.223.445a1.118,1.118,0,0,1,.11.445s-.223-.556-.667-1.447a2.334,2.334,0,0,0-.446-.668c-.11-.223-.333-.445-.556-.779a6.484,6.484,0,0,0-1.558-1.447,15.583,15.583,0,0,0-1.781-1.113c-.333-.111-.556-.223-.889-.334a2.068,2.068,0,0,0-.78-.223A12.212,12.212,0,0,0,34.9,112.1",
    transform: "translate(-5553.428 -14076.228)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16965",
    "data-name": "Group 16965",
    transform: "translate(-5501.267 -14035.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16964",
    "data-name": "Group 16964",
    clipPath: "url(#clip-path-2)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35084",
    "data-name": "Path 35084",
    d: "M52.3,7.751a27.509,27.509,0,0,1,6.9-3.143c2.825.6,8.064,0,8.064,0,.6-.6,3.6-2.949,3.6-2.949.591.255,7.425,1.349,7.425,1.349h7.013s-1.124,2.89,2.17,0S92.284,0,92.284,0l3.13,3.008s-.9.286,1.8.868,1.347-2.768,6.137-.868,5.838,1.855,6.886,2.81,4.79.437,5.239,1.934-10.778,8.865-11.526,8.175-30.087-.787-34.727-2.011S52.3,7.751,52.3,7.751",
    transform: "translate(-45.516)",
    fill: "#34395f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35085",
    "data-name": "Path 35085",
    d: "M105.446,507.9c-.991,3.8-2.064,6.148-3.639,6.237-.125.007-3.845-.053-3.967-.085-2.349-.612-2.918-4.359-1.873-8.37.943-3.616,2.787-6.211,4.958-6.237.236,0,3.415-.042,3.646.018,2.349.612,1.92,4.427.875,8.436",
    transform: "translate(-83.076 -434.609)",
    fill: "#34395f"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35086",
    "data-name": "Path 35086",
    d: "M126.832,508c-1.046,4.01-3.8,6.764-6.146,6.152s-3.405-4.359-2.359-8.369,3.8-6.764,6.146-6.151,3.405,4.36,2.359,8.369",
    transform: "translate(-102.618 -434.71)",
    fill: "#5843be"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35087",
    "data-name": "Path 35087",
    d: "M139.625,527.265c-.619,2.373-2.161,4.025-3.444,3.69s-1.822-2.529-1.2-4.9,2.161-4.025,3.444-3.69,1.822,2.529,1.2,4.9",
    transform: "translate(-117.236 -454.53)",
    fill: "#9b9bd2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35088",
    "data-name": "Path 35088",
    d: "M170.447,56.255H106.716a1.209,1.209,0,0,1-1.209-1.209V53.388a1.209,1.209,0,0,1,1.209-1.209h63.731a1.209,1.209,0,0,1,1.209,1.209v1.658a1.209,1.209,0,0,1-1.209,1.209",
    transform: "translate(-91.814 -45.407)",
    fill: "#b8b8f9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35089",
    "data-name": "Path 35089",
    d: "M169.488,136.3a3.353,3.353,0,0,0,2.444-2.184l7.923-51.046H116.58l7.875,62.338H158.3a1.671,1.671,0,0,0,1.619-1.258l.46-1.938a12.979,12.979,0,0,1,.622-1.962c1.16-2.81,4.728-3.908,8.488-3.949",
    transform: "translate(-101.45 -72.287)",
    fill: "#34395f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35090",
    "data-name": "Path 35090",
    d: "M471.778,507.9c-.991,3.8-2.064,6.148-3.639,6.237-.125.007-3.845-.053-3.967-.085-2.349-.612-2.918-4.359-1.873-8.37.943-3.616,2.787-6.211,4.958-6.237.236,0,3.415-.042,3.646.018,2.349.612,1.92,4.427.875,8.436",
    transform: "translate(-401.863 -434.609)",
    fill: "#34395f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35091",
    "data-name": "Path 35091",
    d: "M493.164,508c-1.046,4.01-3.8,6.764-6.146,6.152s-3.405-4.359-2.359-8.369,3.8-6.764,6.146-6.151,3.405,4.36,2.359,8.369",
    transform: "translate(-421.406 -434.71)",
    fill: "#5843be"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35092",
    "data-name": "Path 35092",
    d: "M505.956,527.265c-.619,2.373-2.161,4.025-3.444,3.69s-1.822-2.529-1.2-4.9,2.161-4.025,3.444-3.69,1.822,2.529,1.2,4.9",
    transform: "translate(-436.022 -454.53)",
    fill: "#9b9bd2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35093",
    "data-name": "Path 35093",
    d: "M63.919,145.406H19.186a2.474,2.474,0,0,1-2.455-2.164L9.13,83.068H73.975L66.3,143.6a2.117,2.117,0,0,1-2.382,1.8",
    transform: "translate(-7.945 -72.287)",
    fill: "#5843be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16963",
    "data-name": "Group 16963",
    transform: "translate(1.185 10.781)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16962",
    "data-name": "Group 16962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16961",
    "data-name": "Group 16961",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35100",
    "data-name": "Path 35100",
    d: "M9.13,83.068h0l.4,3.133H85.864l.486-3.134H9.13Z",
    transform: "translate(-9.13 -83.068)",
    fill: "#e3e3e3"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35101",
    "data-name": "Path 35101",
    d: "M66.839,56.255H1.25A1.25,1.25,0,0,1,0,55.005V53.429a1.25,1.25,0,0,1,1.25-1.25h65.59a1.25,1.25,0,0,1,1.25,1.25v1.576a1.25,1.25,0,0,1-1.25,1.25",
    transform: "translate(0 -45.407)",
    fill: "#9b9bd2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "recycle",
    transform: "translate(-5475.995 -14002.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35102",
    "data-name": "Path 35102",
    d: "M12.694,23.231l.769.462c.125,0,.191-.054.191-.158a.686.686,0,0,0-.089-.28l-1.67-3.135-3.7.089a.233.233,0,0,0-.251.259c0,.039.054.089.158.158l.767.462-.826,1.262a1.834,1.834,0,0,0-.337.895,1.464,1.464,0,0,0,.224.716l2.514,4.384a3.752,3.752,0,0,1-.089-.787,2.386,2.386,0,0,1,.421-1.318L12.7,23.231Z",
    transform: "translate(-7.71 -14.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35103",
    "data-name": "Path 35103",
    d: "M19.628,8.19,21.7,4.969Q20.538,2.32,19.231,2.32a1.149,1.149,0,0,0-1.059.438L16.21,5.893Z",
    transform: "translate(-13.675 -1.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35104",
    "data-name": "Path 35104",
    d: "M19.537,41.361h4V37.2H19.683a14.14,14.14,0,0,0-.895,1.375,2.583,2.583,0,0,0-.3,1.172q0,1.614,1.038,1.614Z",
    transform: "translate(-15.275 -26.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35105",
    "data-name": "Path 35105",
    d: "M34.058,6.326l1.79-2.983a.662.662,0,0,0,.089-.328c0-.134-.045-.2-.134-.2a.755.755,0,0,1-.182.069l-.82.343L34.058,1.76A1.982,1.982,0,0,0,32.081.77H27.44a3.624,3.624,0,0,1,1.148.507,6.065,6.065,0,0,1,1.455,2.118l.925,1.939-.677.328a.179.179,0,0,0-.1.182c0,.11.072.176.215.191l3.666.3Z",
    transform: "translate(-21.555 -0.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35106",
    "data-name": "Path 35106",
    d: "M43.249,37.982l2.592-4.712a2.89,2.89,0,0,1-1.25.88,5.151,5.151,0,0,1-1.545.182H40.159v-.6q0-.349-.17-.349a.194.194,0,0,0-.179.089L38,36.64l1.894,2.911c.143.218.265.3.37.257s.158-.084.158-.167v-.993h1.6a1.291,1.291,0,0,0,1.241-.665Z",
    transform: "translate(-28.966 -23.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35107",
    "data-name": "Path 35107",
    d: "M46.992,22.013h1.724A2.061,2.061,0,0,0,50,21.47a1.55,1.55,0,0,0,.71-1.193,1.035,1.035,0,0,0-.191-.576L48.468,16.57,44.94,18.622Z",
    transform: "translate(-33.836 -11.858)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16966",
    "data-name": "Group 16966",
    transform: "translate(-5518.525 -14074.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35108",
    "data-name": "Path 35108",
    d: "M.629.175A1.509,1.509,0,0,1,2.186.268l6.7,3.757a4.2,4.2,0,0,1,1.956,3.192l.12,3.008a1.5,1.5,0,0,1-.623,1.428,1.507,1.507,0,0,1-1.556-.093L2.066,7.794A4.189,4.189,0,0,1,.114,4.6L0,1.6A1.51,1.51,0,0,1,.629.175M2.042,4.528a2.324,2.324,0,0,0,.967,1.584L9,9.472,8.911,7.3a2.339,2.339,0,0,0-.973-1.588L1.961,2.354Z",
    transform: "translate(19.593 3.109) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35109",
    "data-name": "Path 35109",
    d: "M6.081,3.971A3.933,3.933,0,0,0,4.29,1.1L2.788.259A1.879,1.879,0,0,0,.219.9a1.878,1.878,0,0,0,.8,2.525L4.533,5.4A8.2,8.2,0,0,1,6.177,6.748s-.064-2.211-.07-2.333Z",
    transform: "translate(17.615 1.933) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11179",
    "data-name": "Rectangle 11179",
    width: 5.081,
    height: 10.692,
    transform: "matrix(-0.785, -0.62, 0.62, -0.785, 15.051, 14.393)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35110",
    "data-name": "Path 35110",
    d: "M6.709,0,7.4,2.462.7,4.345,0,1.845Z",
    transform: "translate(25.923 16.685) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35111",
    "data-name": "Path 35111",
    d: "M0,1.883,6.7,0l.694,2.468L.683,4.312Z",
    transform: "translate(25.634 14.14) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35112",
    "data-name": "Path 35112",
    d: "M0,.3,1.1,0l.78,2.774-1.1.3Z",
    transform: "translate(31.551 14.652) rotate(9)",
    fill: "#5943bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35113",
    "data-name": "Path 35113",
    d: "M1.1,0l.777,2.764-1.1.3L0,.3Z",
    transform: "translate(31.887 17.514) rotate(9)",
    fill: "#5943bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35114",
    "data-name": "Path 35114",
    d: "M15.857,1.951a5.793,5.793,0,0,1,2.294,2.773l.932,2.789a4.991,4.991,0,0,1-.332,3.512L10.486,25.755a1.936,1.936,0,0,1-2.627.738L0,22.084,12.379,0Z",
    transform: "translate(12.925 9.119) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35115",
    "data-name": "Path 35115",
    d: "M10.746.984A1.935,1.935,0,0,1,13.372.245L21.23,4.654,8.851,26.738.984,22.324A1.935,1.935,0,0,1,.245,19.7Z",
    transform: "translate(4.911 3.137) rotate(9)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35116",
    "data-name": "Path 35116",
    d: "M15.467,1.951A5.4,5.4,0,0,1,17.578,4.5l.932,2.789a4.593,4.593,0,0,1-.3,3.19L9.943,25.213a1.534,1.534,0,0,1-2.084.586L0,21.389,11.99,0Z",
    transform: "translate(13.063 9.492) rotate(9)",
    fill: "#5943bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35117",
    "data-name": "Path 35117",
    d: "M.2,19.495,10.7.781A1.534,1.534,0,0,1,12.781.195L20.638,4.6,8.648,25.993.781,21.579A1.532,1.532,0,0,1,.2,19.495",
    transform: "translate(5.241 3.592) rotate(9)",
    fill: "#5943bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35118",
    "data-name": "Path 35118",
    d: "M2.877,8.314a.976.976,0,0,0,1.3-.365L6.344,4.08a.954.954,0,0,0-.365-1.3L4.056,1.7,5.012,0,6.936,1.079a2.892,2.892,0,0,1,.979.9l4.631-1.3a.977.977,0,0,1,.529,1.881L8.405,3.875a2.882,2.882,0,0,1-.358,1.161L5.877,8.9a2.9,2.9,0,0,1-.884.972L6.321,14.6a.977.977,0,0,1-.677,1.2.962.962,0,0,1-.393.028.978.978,0,0,1-.812-.7L3.1,10.371c-.05,0-.1,0-.149-.009a2.869,2.869,0,0,1-1.031-.345L0,8.94l.955-1.7Z",
    transform: "translate(14.683 17.266) rotate(9)",
    fill: "#bab8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35119",
    "data-name": "Path 35119",
    d: "M.713,13.279l4.7-1.321a2.876,2.876,0,0,1,.366-1.282L7.95,6.807a2.9,2.9,0,0,1,.822-.923L7.467,1.242A.977.977,0,0,1,9.348.713l1.3,4.623c.076,0,.151,0,.226.013a2.891,2.891,0,0,1,1.031.345l1.945,1.091L12.9,8.49,10.95,7.4a.887.887,0,0,0-.737-.069l-.017.007h-.008a.945.945,0,0,0-.534.425l-2.171,3.87a.957.957,0,0,0,.364,1.3L9.8,14.022l-.955,1.7L6.891,14.632a2.865,2.865,0,0,1-.906-.805L1.241,15.16a.962.962,0,0,1-.393.028.977.977,0,0,1-.135-1.909",
    transform: "translate(7.013 9.181) rotate(9)",
    fill: "#bab8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35120",
    "data-name": "Path 35120",
    d: "M4.111,7A4.1,4.1,0,0,1,0,11.083V0S4.113,4.737,4.111,7",
    transform: "translate(33.489 22.512) rotate(9)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35121",
    "data-name": "Path 35121",
    d: "M4.168,0V11.083H4.159A4.127,4.127,0,0,1,0,6.989C0,4.731,4.168,0,4.168,0",
    transform: "translate(29.418 21.867) rotate(9)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35122",
    "data-name": "Path 35122",
    d: "M0,1.63a.775.775,0,1,0,1.55,0V.775A.775.775,0,0,0,0,.775Z",
    transform: "translate(34.127 29.368) rotate(9)",
    fill: "#5843be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11180",
    "data-name": "Rectangle 11180",
    width: 35.368,
    height: 34.569,
    transform: "translate(5.408 0) rotate(9)",
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16967",
    "data-name": "Group 16967",
    transform: "translate(-5449.541 -14058.266) rotate(-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35126",
    "data-name": "Path 35126",
    d: "M3.65,1.214,2.77,2.7a1.409,1.409,0,0,1-1.93.5L0,2.7,1.6,0Z",
    transform: "translate(1.533 17.671)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35127",
    "data-name": "Path 35127",
    d: "M3.129,1.214l-1.6,2.7-.84-.5a1.409,1.409,0,0,1-.5-1.93L1.076,0Z",
    transform: "translate(0 16.457)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35128",
    "data-name": "Path 35128",
    d: "M0,7.1l1.407.077a20.464,20.464,0,0,1,.923-5.41.53.53,0,0,1,.361-.277,6.377,6.377,0,0,1,3.373.6L6.776.869C6.537.727,3.969-.375,2.3.133A1.951,1.951,0,0,0,1.059,1.154C.24,2.865.009,6.924,0,7.1",
    transform: "translate(8.209 13.711)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35129",
    "data-name": "Path 35129",
    d: "M3.86,13.326a.739.739,0,0,0,1.012-.26L9.089,5.932a.739.739,0,0,0-.26-1.012L5.685,3.062,7.5,0l4.313,2.55a1.409,1.409,0,0,1,.5,1.93L6.243,14.734a1.41,1.41,0,0,1-1.93.5L0,12.681l.716-1.213Z",
    transform: "translate(6.007 7.524)",
    fill: "#5843be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35130",
    "data-name": "Path 35130",
    d: "M8.188.2,12.5,2.746l-1.81,3.062L9.61,5.169a.739.739,0,0,0-1.012.26L4.381,12.562a.739.739,0,0,0,.26,1.012l1.081.639-.716,1.213L.692,12.877a1.409,1.409,0,0,1-.5-1.93L6.258.692A1.409,1.409,0,0,1,8.188.2",
    transform: "translate(1.002 4.777)",
    fill: "#5843be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35131",
    "data-name": "Path 35131",
    d: "M15.568.433l-.055,1.4L7.012,1.5.631,4.76,0,3.525,6.7,0Z",
    transform: "translate(17.855 1.33)",
    fill: "#9b9bd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35132",
    "data-name": "Path 35132",
    d: "M6.71.154A1.407,1.407,0,0,1,7.405,0l8.869.347-.055,1.416L7.35,1.331.651,4.855,0,3.58Z",
    transform: "translate(17.203 0)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35133",
    "data-name": "Path 35133",
    d: "M0,.733,1.494.064A.727.727,0,0,1,2.455.43l1.657,3.7a.727.727,0,0,1-.367.961L2.252,5.76Z",
    transform: "translate(17.907 1.002)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35134",
    "data-name": "Path 35134",
    d: "M11.2,12.371h0L.15,5.838,0,2.749,3.912,0Z",
    transform: "translate(6.811 0.137)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35135",
    "data-name": "Path 35135",
    d: "M0,0,7.325.468l3.258,6.578L7.29,12.371Z",
    transform: "translate(10.722 0.137)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11181",
    "data-name": "Rectangle 11181",
    width: 35.88,
    height: 22.949,
    transform: "translate(0 0.001)",
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16968",
    "data-name": "Group 16968",
    transform: "translate(-5468.429 -14088.907) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35136",
    "data-name": "Path 35136",
    d: "M12.508.6A1.328,1.328,0,0,0,11.274,0L4.526,0A3.693,3.693,0,0,0,1.654,1.609L.269,3.863A1.321,1.321,0,0,0,.133,5.226a1.323,1.323,0,0,0,1.232.6l6.767,0A3.683,3.683,0,0,0,11,4.211l1.374-2.249A1.328,1.328,0,0,0,12.508.6M9.555,3.327a2.043,2.043,0,0,1-1.422.8l-6.036,0L3.1,2.5a2.058,2.058,0,0,1,1.428-.8l6.025,0Z",
    transform: "translate(5.887 0)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35137",
    "data-name": "Path 35137",
    d: "M1.266,1.431A3.457,3.457,0,0,1,3.874,0H5.387a1.652,1.652,0,0,1,1.7,1.593,1.652,1.652,0,0,1-1.7,1.594H1.841A7.221,7.221,0,0,0,0,3.518S1,1.85,1.056,1.76Z",
    transform: "translate(13.323 0)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11182",
    "data-name": "Rectangle 11182",
    width: 4.466,
    height: 9.397,
    transform: "translate(15.942 1.594)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35138",
    "data-name": "Path 35138",
    d: "M1.589,0,0,1.59,4.325,5.913,5.94,4.3Z",
    transform: "translate(0.463 3.771)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35139",
    "data-name": "Path 35139",
    d: "M5.918,4.322,1.593,0,0,1.594l4.35,4.3Z",
    transform: "translate(2.052 2.178)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35140",
    "data-name": "Path 35140",
    d: "M2.5.706,1.79,0,0,1.791.714,2.5Z",
    transform: "translate(1.784 1.715)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35141",
    "data-name": "Path 35141",
    d: "M1.784,0,0,1.785l.714.706L2.5.706Z",
    transform: "translate(0 3.506)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35142",
    "data-name": "Path 35142",
    d: "M6.118,0A5.093,5.093,0,0,0,3.168,1.142L1.254,2.88A4.386,4.386,0,0,0,0,5.715L.006,20.56a1.7,1.7,0,0,0,1.7,1.695l7.921,0V0Z",
    transform: "translate(1.169 3.19)",
    fill: "#34395f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35143",
    "data-name": "Path 35143",
    d: "M9.616,1.7A1.7,1.7,0,0,0,7.92,0L0,0V22.255l7.928,0a1.7,1.7,0,0,0,1.695-1.7Z",
    transform: "translate(10.792 3.187)",
    fill: "#31404f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35144",
    "data-name": "Path 35144",
    d: "M5.769,0A4.753,4.753,0,0,0,3.053,1.051L1.14,2.789A4.04,4.04,0,0,0,0,5.365L.006,20.21a1.35,1.35,0,0,0,1.346,1.345l7.921,0V0Z",
    transform: "translate(1.519 3.54)",
    fill: "#5843be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35145",
    "data-name": "Path 35145",
    d: "M9.273,20.206,9.266,1.345A1.349,1.349,0,0,0,7.92,0L0,0V21.555l7.928,0a1.347,1.347,0,0,0,1.345-1.346",
    transform: "translate(10.791 3.537)",
    fill: "#5843be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35146",
    "data-name": "Path 35146",
    d: "M1.846,0C2.9,0,3.691.2,3.691,2.289c0,1.967-.75,2.223-1.845,2.223S0,4.318,0,2.289C0,.2.822,0,1.846,0m0,3.453c.524,0,.664-.219.664-1.164,0-1.035-.11-1.23-.664-1.23-.537,0-.665.14-.665,1.23,0,.932.067,1.164.665,1.164",
    transform: "translate(6.181 19.037)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11183",
    "data-name": "Rectangle 11183",
    width: 1.181,
    height: 4.458,
    transform: "translate(10.294 19.067)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35147",
    "data-name": "Path 35147",
    d: "M0,0H1.181V3.081c0,.323.2.317.378.317H2.814v1.06h-1.8A.892.892,0,0,1,0,3.508Z",
    transform: "translate(11.952 19.067)",
    fill: "#b8b8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35148",
    "data-name": "Path 35148",
    d: "M0,5.555A3.258,3.258,0,0,0,3.264,8.8V0S0,3.761,0,5.555",
    transform: "translate(7.474 9.017)",
    fill: "#edeff8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35149",
    "data-name": "Path 35149",
    d: "M0,0V8.8H.007A3.258,3.258,0,0,0,3.272,5.55C3.271,3.756,0,0,0,0",
    transform: "translate(10.738 9.017)",
    fill: "#edeff8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11184",
    "data-name": "Rectangle 11184",
    width: 20.415,
    height: 25.445,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.f439893226370df7f29d56cf8e7326c9.svg";
export { ForwardRef as ReactComponent };